import * as React from 'react'
import RiskAssessmentPreview from './riskAssessmentPreview'
import { SidebarScrollingContainer } from 'Components/layout'
import { LoadingSpinner, Sidebar } from 'Components/readonly'

import styled from 'styled-components'
import { RiskAssessmentContext } from '../context/riskAssessmentContext'
import useRiskAssessmentDetail from '../hooks/useRiskAssessmentDetail'

const ViewSidebar = styled(Sidebar)`
  width: 40%;

  &&& .p-sidebar-content {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
  }

  @media screen and (max-width: 992px) {
    width: 90%;
  }
`

const ViewSidebarScrollingContainer = styled(SidebarScrollingContainer)`
  flex: 1 1 auto;
  min-height: 0;
`

const RiskAssessmentViewSidebar = ({
  selectedAssessmentId,
  fallbackRiskAssessment,
  riskSidebarVisible,
  setRiskSidebarVisible
}) => {
  const { selectedProduct } = React.useContext(RiskAssessmentContext)
  const useDetailEndpoint = !!selectedAssessmentId
  const { isLoading, product, riskAssessment } = useRiskAssessmentDetail(
    selectedAssessmentId,
    riskSidebarVisible && useDetailEndpoint
  )

  const riskAssessmentToShow = useDetailEndpoint ? riskAssessment : fallbackRiskAssessment
  const productForPreview = (useDetailEndpoint ? product : null) || selectedProduct || fallbackRiskAssessment?.chemical
  const showLoading = useDetailEndpoint && isLoading

  return (
    <ViewSidebar
      className="risk-assessment-view"
      blockScroll={true}
      visible={riskSidebarVisible}
      position="right"
      onHide={() => setRiskSidebarVisible(false)}>
      {riskSidebarVisible && (
        <ViewSidebarScrollingContainer>
          {showLoading ? (
            <LoadingSpinner isLoading={true} />
          ) : (
            productForPreview &&
            riskAssessmentToShow && (
              <RiskAssessmentPreview product={productForPreview} riskAssessment={riskAssessmentToShow} />
            )
          )}
        </ViewSidebarScrollingContainer>
      )}
    </ViewSidebar>
  )
}

export default RiskAssessmentViewSidebar
